import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=129437c2"
import script from "./TagBadge.vue?vue&type=script&lang=ts"
export * from "./TagBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports